import styled from 'styled-components'

import { ButtonPlain } from '@subaio/components'

import { helpers } from 'styles'

export const Button = styled(ButtonPlain)`
	position: relative;
	display: flex;
	justify-content: space-between;
	align-items: center;
	column-gap: 8px;
	font-size: ${helpers.font.size.base};
	line-height: 1.2;
	color: ${helpers.color.link};
	background-color: transparent;
	transition: background-color 135ms ease;
	margin: 0;
	padding: 8px 0;
	border-radius: 2px;

	text-decoration: underline;
	text-underline-offset: 2px;

	&:active {
		background-color: ${helpers.color.listActive};
	}

	&:focus-visible {
		outline: 2px solid ${helpers.color.buttonFocus} !important;
	}

	&:hover, &:focus-visible {
		text-decoration: underline;
		color: ${helpers.color.linkHighlight};
	}

	&:disabled {
		color: ${helpers.color.disabled};
		text-decoration: none;
		box-shadow: none;
		cursor: default;
		background-color: transparent;
	}
`
